import environment from "./env";

const config = () => {
    const env = environment[process.env.HOST];
    const { redirectUri } = env.passwordReset;
    const version = process.env.version;

    return {
        api: {
            currentEnvUrl: redirectUri.replace("pwa", "").replace("-", ""),
            supportUrl: "/static/app-support.html",
            privacyUrl: "/static/app-privacy-policy.html",
            baseUrl: env.api.url,
            paths: {
                assetSync: "/v1/asset-sync/",
                auditAssignment: "/v1/audit-assignment/",
                auditAssignmentStatus: "/v1/audit-assignments/get-statuses/",
                auditAssignmentBulkUpdate: "/v1/audit-assignment-bulk-update/",
                auditDownload: "/v1/audit-download/",
                auditSubmissions: "/v1/audit-submissions/",
                me: "/v1/me/",
                userLanguage: "/v1/user-language/",
                typesList: "/v1/types-list/",
                sendMail: "/v1/mail/",
                organisations: "/v1/user-organisations/"
            }
        },
        asset: {
            maxValue: 2000000,
            moreOffset: 20 // number of assets to preload on showMore click in assets list
        },
        assetSync: {
            timeout: 30000
        },
        geoLocation: {
            interval: 60000,
            options: {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 15000
            }
        },
        altAsset: {
            ...env.altAsset
        },
        auth: { ...env.auth, appClientId: env.clientId },
        pagination: {
            rowsPerPageOptions: [10, 20, 50, 100]
        },
        toaster: {
            AUTO_HIDE_DURATION: 4000
        },
        passwordReset: { ...env.passwordReset, clientId: env.clientId },
        paths: {
            audits: "audits",
            groupedAudits: "groupedAudits",
            assets: "assets",
            auditAssets: "audit-assets",
            settings: "settings",
            contactForm: "contact-form",
            ///
            auth: "auth",
            signIn: "sign-in",
            search: "search",
            login: "login",
            logout: "logout",
            profile: "profile",
            validationErrors: "validation-errors",
            troubleshoot: "troubleshoot"
        },
        regex: {
            email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            split: /(?=[A-Z0-9])/
        },
        version,
        env: process.env.HOST,
        sentryDsn: env.sentryDsn,
        appInsight: env.appInsightConfig,
        permissionsReadme: "/auth/troubleshoot"
    };
};

export default config();
